import { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { api, errMsg } from "../lib/api";

export default function ResetPasswordPage() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [pw, setPw] = useState("");
  const [confirm, setConfirm] = useState("");
  const [msg, setMsg] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (pw !== confirm) return setError("Passwords do not match");
    setBusy(true);
    try {
      const { data } = await api.post("/auth/reset-password", { token, new_password: pw });
      setMsg(data.message);
    } catch (err) {
      setError(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-6 ledger-grid">
      <form onSubmit={submit} className="w-full max-w-sm bg-surface border border-line p-8 rise" data-testid="reset-form">
        <h2 className="font-display text-3xl font-bold tracking-tight">Set new password</h2>
        {!token ? (
          <p className="text-sm text-neg mt-4" data-testid="reset-missing-token">This reset link is incomplete. Please request a new one.</p>
        ) : msg ? (
          <p className="text-sm text-pos mt-4" data-testid="reset-success">{msg}</p>
        ) : (
          <>
            <p className="text-sm text-muted-c mt-1 mb-6">Choose a new password (at least 6 characters).</p>
            <div className="mb-4">
              <Label>New password</Label>
              <Input type="password" required minLength={6} value={pw} onChange={(e) => setPw(e.target.value)} className="mt-1 rounded-none" data-testid="reset-password-input" />
            </div>
            <div className="mb-4">
              <Label>Confirm password</Label>
              <Input type="password" required value={confirm} onChange={(e) => setConfirm(e.target.value)} className="mt-1 rounded-none" data-testid="reset-confirm-input" />
            </div>
            {error && <p className="text-sm text-neg mb-3" data-testid="reset-error">{error}</p>}
            <Button type="submit" disabled={busy} className="w-full rounded-none bg-brand hover:bg-brand/90 text-onbrand" data-testid="reset-submit-button">
              {busy ? "Saving…" : "Update password"}
            </Button>
          </>
        )}
        <Link to="/login" className="mt-4 block text-sm text-brand hover:underline text-center" data-testid="reset-go-login-link">Go to sign in</Link>
      </form>
    </div>
  );
}
